import { IBannerInlinePlaceholderProps } from '@tekface/smart-activation';
import { ProductDetailProvider, useTenantConfig } from 'contexts';
import { DetailPage, DetailPageSGC } from 'modules/product-detail/desktop';
import { getServerSidePropsDetail } from 'modules/product-detail/shared';
import { ProductResponse } from 'types';

export interface ProductDetailsProps {
  serverProduct: ProductResponse;
  inlineBanners?: IBannerInlinePlaceholderProps<{}>['banners'];
}
const ProductDetails: React.FC = () => {
  const { displayNewLayoutForProductDetailSGC } = useTenantConfig();

  return displayNewLayoutForProductDetailSGC ? (
    <DetailPageSGC />
  ) : (
    <DetailPage />
  );
};
const ProductDetailsPage: React.FunctionComponent<ProductDetailsProps> = ({
  serverProduct,
  inlineBanners,
}: ProductDetailsProps) => {
  return (
    <ProductDetailProvider
      serverProduct={serverProduct}
      inlineBanners={inlineBanners}
    >
      <ProductDetails />
    </ProductDetailProvider>
  );
};
export const getServerSideProps = getServerSidePropsDetail;
export default ProductDetailsPage;
